import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'
import type { FC } from 'react'
import { Controller } from 'react-hook-form'
import { useAreaFormContext } from '../AreaFormContext'
import { notationOrderLabel, notationOrders } from './dateFormats'

export const NotationOrder: FC = () => {
  const { control } = useAreaFormContext()

  return (
    <Controller
      name="expirationNotationOrder"
      control={control}
      render={({ field }) => (
        <FormControl required sx={{ gap: 0.5 }}>
          <Typography
            component="label"
            sx={{ color: 'text.primary', fontSize: 14, fontWeight: 'bold' }}
          >
            表記順
          </Typography>
          <RadioGroup
            row
            value={field.value}
            onChange={e => field.onChange(e.target.value)}
          >
            {notationOrders.map(v => (
              <FormControlLabel
                key={v}
                value={v}
                control={<Radio size="small" />}
                label={notationOrderLabel[v]}
                sx={{ color: 'text.primary' }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      )}
    />
  )
}
